import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnChanges
} from '@angular/core';
import { Config, Menu, Submenu } from './types';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { AccordionService } from './accordion.service';
import { Messages, ProductsNavRoutes } from '@tmhcc-ng-lib/models';
import { GlobalVariablesService } from '@tmhcc-ng-lib/data-service';
import { CustomModalComponent } from 'libs/artisan-edge/src/lib/custom-modal/custom-modal.component';
import { FormGroup } from '@angular/forms';

import {
  DialogContainerComponent,
  SaveChangeGaurd
} from '@tmhcc-ng-lib/global-services';
import {
  DialogConfig,
  DialogService,
  DialogSize
} from '@tmhcc-ng-lib/framwork/dialog';
import { AllowedGLNavRoutes } from 'libs/models/enums/gl-menus.model';
import { AllowedEXNavRoutes } from 'libs/models/enums/ex-menus.model';
import { AllowedPLNavRoutes } from 'libs/models/enums/pl-menus.model';

@Component({
  selector: 'accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit, OnChanges {
  @Input() options;
  @Input() menus: Menu[];
  @Input() bound: boolean;
  @Input() additional: boolean;
  @Input() declined: boolean;
  config: Config;
  index: number;
  //bound;
  clicked = 'Policy Snapshot';
  currentUrl = '';
  navigationUrl = '';
  formGroup: FormGroup;
  isFormCompleted: boolean;
  errMessage: string =
    'You are able to be taken to the fully editable renewal application from A new application will be generated which must be signed prior to be binding.Are you sure you want to do this?';
  modalTitle: string = 'EDIT POLICY INFORMATION';
  modalContent: DialogConfig = {
    data: {
      para: '',
      footerBtnLabel: '',
      showFooterBtn: true
    },
    modalSetting: {
      title: '',
      hideHeader: false,
      hideFooter: true,
      hideHeaderX: false, // header X button;
      hideSave: true,
      closeOnOutsideClick: true
    }
  };
  @Output() menuName = new EventEmitter();
  removedSubmenu: Submenu[];
  documentNavHeight = 0;
  allSteps;
  constructor(
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private accordionService: AccordionService,
    private globalVariables: GlobalVariablesService,
    private saveChangeGaurd: SaveChangeGaurd,
    private dialogService: DialogService,
    private dialogConfig: DialogConfig
  ) { }

  ngOnInit() {
    this.config = this.mergeConfig(this.options);
    this.currentUrl = location.pathname;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.navigationUrl = event.url;
      }
      if (event instanceof NavigationEnd) {
        this.currentUrl = location.pathname;
      }
    });

    this.globalVariables.updateStep.subscribe(
      allSteps => (this.allSteps = allSteps)
    );
  }
  ngOnChanges() {
    this.accordionService.documentSubmenu().subscribe(hideDocumentSubmenu => {
      let prodType = this.globalVariables.productName;
      let navRputes = ProductsNavRoutes[prodType];
      if (hideDocumentSubmenu && this.menus) {
        if (this.menus[2] && this.menus[2].submenu) {
          let indexOfDocument = this.menus[2].submenu.findIndex(
            path => path.url === navRputes.Document
          );
          if (indexOfDocument > -1) {
            this.removedSubmenu = this.menus[2].submenu.splice(
              indexOfDocument,
              1
            );
          }
        }
      } else if (this.removedSubmenu) {
        this.menus[2].submenu.push(this.removedSubmenu[0]);
        this.removedSubmenu = null;
      }
    });
  }

  mergeConfig(options: Config) {
    const config = {
      // selector: '#accordion',
      multi: true
    };
    return { ...config, ...options };
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  disabletoggle(index: number) {
    this.index = index;
    if (this.router.url.endsWith('renewalreview')) {
      this.openModal();
    } else {
      this.toggle(index);
    }
  }
  toggle(index) {
    // this.openModal();
    if (location.pathname.includes('pending-review')) {
      return;
    }
    if (!this.config.multi) {
      this.menus
        .filter((menu, i) => i !== index && menu.active)
        .forEach(menu => (menu.active = !menu.active));
    }
    // Menu active
    this.menus[index].active = !this.menus[index].active;
    //
  }

  openModal() {
    this.modalContent.data = {
      para: this.errMessage,
      noBtnLabel: 'No',
      yesBtnLabel: 'Yes',
      showFooterBtn: true,
      noBtnCallback: this.noPopup.bind(this),
      yesBtnCallback: this.yesPopup.bind(this)
    };
    this.modalContent.modalSetting = {
      title: this.modalTitle,
      hideFooter: true,
      hideSave: false
    };
    this.dialogService.open(CustomModalComponent, this.modalContent);
  }

  noPopup() {
    this.dialogService.close();
    return;
  }
  yesPopup() {
    this.dialogService.close();
    this.toggle(this.index);
  }

  getName(name: string) {
    if (this.saveChangeGaurd.formGroup.dirty) {
      this.showDirtyCheckDialog(name);
    } else {
      this.clicked = name;
      this.menuName.emit(name);
    }
  }

  showDirtyCheckDialog(name) {
    let content = {
      value: Messages.DirtyCheck
    };
    this.dialogConfig.data = content;

    this.dialogConfig.modalSetting = {
      title: '',
      hideHeader: false,
      hideFooter: true,
      hideSave: true,
      hideHeaderX: false,
      SaveButton: 'Yes',
      CancelButton: 'No',
      dialogSize: DialogSize.SM
    };
    const ref = this.dialogService.open(
      DialogContainerComponent,
      this.dialogConfig
    );
    ref.afterClosed.subscribe(result => {
      if (result) {
        this.saveChangeGaurd.formGroup.markAsPristine();
        this.clicked = name;
        this.menuName.emit(name);
      }
    });
  }
  disableAdditionalMenu() {
    if (
      this.router.url == '/additional/adinsured' ||
      this.router.url == '/additional/addforms' ||
      this.router.url == '/additional/reviewsubmit' ||
      this.router.url == '/ac-ucm-forms/gl-address-review' ||
      this.router.url == '/ec-ucm-forms/gl-review-submit' ||
      this.router.url == '/ac-ucm-forms/gl-address-review' ||
      this.router.url == '/ac-ucm-forms/gl-address-edit' ||
      this.router.url == '/ec-ucm-forms/gl-payroll-receipt' ||
      this.router.url == '/cc-ucm-forms/gl-classification'
    ) {
      return true;
    } else {
      return false;
    }
  }

  validateBeforeNavigate() {
    if ((this.router.url == AllowedGLNavRoutes.Owner ||
      this.router.url == AllowedGLNavRoutes.Ratings ||
      this.router.url == AllowedGLNavRoutes.Liability || 
      this.router.url == AllowedGLNavRoutes.ExcessCoverage || 
      this.router.url == AllowedGLNavRoutes.Property ||      
      this.router.url == AllowedEXNavRoutes.Owner ||
      this.router.url == AllowedEXNavRoutes.Ratings ||       
      this.router.url == AllowedPLNavRoutes.Owner ||
      this.router.url == AllowedPLNavRoutes.Ratings ||          
      this.router.url == AllowedEXNavRoutes.Excess ||
      this.router.url == AllowedEXNavRoutes.Automobile ||
      this.router.url == AllowedEXNavRoutes.Employeebenefits
      ) && sessionStorage.cachedState == 'true') {
      if (this.saveChangeGaurd.formGroup != undefined) {
        this.saveChangeGaurd.formGroup.markAsDirty();
      }
    }
  }
}
